import { metaFn } from '@common/router/meta-fn';
export const metaFnGuard = async function (to, from, next) {
  await metaFn(to.matched, to);
  next();
};
